// Orígenes de sincronización por instancia
export const SYNC_ORIGINS = {
  ARGENTINA: ['pedidos ya', 'rappi', 'rappi turbo', 'mp delivery', 'uber eats'],
  MEXICO: ['rappi', 'rappi turbo', 'uber eats', 'didi food', 'deliverect'],
  SPAIN: ['honei', 'deliverect'],
  DEFAULT: []
};

// Mapeo de sources string a int para API backend
export const SOURCE_IDS = {
  'BOrders': 1,
  'MP Delivery': 2,
  'Uber Eats': 3,
  'Pedidos Ya': 4,
  'Glovo': 5,        // Not implemented
  'Rappi': 6,
  'Mas Delivery': 7, // Not implemented
  'Deliverect': 8,
  'BKiosk': 9,
  'Didi Food': 10,
  'Honei': 11,
  'Rappi Turbo': 13
};

// Función helper para obtener el ID del source
export const getSourceId = (sourceName) => {
  return SOURCE_IDS[sourceName] || null;
};

// Enum de StoreStatusFilter del backend
export const STORE_STATUS_FILTER = {
  CLOSED: 0,
  OPEN: 1,
  SUSPENDED: 2,
  NOT_INTEGRATED: 3,
  UNKNOWN: 99
};

// Enum de MenuStatusFilter del backend
export const MENU_STATUS_FILTER = {
  PENDING: 1,
  SYNC_OK: 2,
  SYNC_ERROR: 3,
  INCOMPLETE: 4,
  UNKNOWN: 99
};

// Mapeo de valores de backend a frontend para StoreStatus
export const STORE_STATUS_BACKEND_TO_FRONTEND = {
  [STORE_STATUS_FILTER.CLOSED]: 'Cerradas',
  [STORE_STATUS_FILTER.OPEN]: 'Abiertas',
  [STORE_STATUS_FILTER.NOT_INTEGRATED]: 'Sin integrar',
  [STORE_STATUS_FILTER.SUSPENDED]: 'Suspendidas',
  [STORE_STATUS_FILTER.UNKNOWN]: 'Desconocido'
};

// Mapeo de valores de frontend a backend para StoreStatus
export const STORE_STATUS_FRONTEND_TO_BACKEND = {
  'Cerradas': STORE_STATUS_FILTER.CLOSED,
  'Abiertas': STORE_STATUS_FILTER.OPEN,
  'Sin integrar': STORE_STATUS_FILTER.NOT_INTEGRATED,
  'Suspendidas': STORE_STATUS_FILTER.SUSPENDED,
  'Desconocido': STORE_STATUS_FILTER.UNKNOWN
};

// Mapeo de valores de backend a frontend para MenuStatus
export const MENU_STATUS_BACKEND_TO_FRONTEND = {
  [MENU_STATUS_FILTER.PENDING]: 'Pendiente',
  [MENU_STATUS_FILTER.SYNC_OK]: 'Sincronizada',
  [MENU_STATUS_FILTER.SYNC_ERROR]: 'Error de sincronización',
  [MENU_STATUS_FILTER.INCOMPLETE]: 'Incompleto',
  [MENU_STATUS_FILTER.UNKNOWN]: 'Desconocido'
};

// Mapeo de valores de frontend a backend para MenuStatus
export const MENU_STATUS_FRONTEND_TO_BACKEND = {
  'Pendiente': MENU_STATUS_FILTER.PENDING,
  'Sincronizada': MENU_STATUS_FILTER.SYNC_OK,
  'Error de sincronización': MENU_STATUS_FILTER.SYNC_ERROR,
  'Incompleto': MENU_STATUS_FILTER.INCOMPLETE,
  'Desconocido': MENU_STATUS_FILTER.UNKNOWN
};

// Función helper para mapear StoreStatus de backend a frontend
export const mapStoreStatusToFrontend = (backendValue) => {
  return STORE_STATUS_BACKEND_TO_FRONTEND[backendValue] || null;
};

// Función helper para mapear StoreStatus de frontend a backend
export const mapStoreStatusToBackend = (frontendValue) => {
  const result = STORE_STATUS_FRONTEND_TO_BACKEND[frontendValue];
  // Retornar el valor incluso si es 0 (falsy), solo retornar null si es undefined
  return result !== undefined ? result : null;
};

// Función helper para mapear MenuStatus de backend a frontend
export const mapMenuStatusToFrontend = (backendValue) => {
  return MENU_STATUS_BACKEND_TO_FRONTEND[backendValue] || null;
};

// Función helper para mapear MenuStatus de frontend a backend
export const mapMenuStatusToBackend = (frontendValue) => {
  return MENU_STATUS_FRONTEND_TO_BACKEND[frontendValue] || null;
};

// FDS disponibles por instancia/país (ordenados alfabéticamente)
export const FDS_BY_INSTANCE = {
  'AR': ['MP Delivery', 'Pedidos Ya', 'Rappi', 'Rappi Turbo', 'Uber Eats'],
  'MX': ['Deliverect', 'Didi Food', 'Rappi', 'Rappi Turbo', 'Uber Eats'],
  'ES': ['Deliverect', 'Honei'],
  'UY': ['Pedidos Ya', 'Rappi', 'Rappi Turbo'],
  'ENERGY_POS_SV': []
};

// Devuelve la lista de FDS para la instancia actual como objetos { source, sourceLabel }
export const getFdsPlatformsByInstance = (instanceCode) => {
  const code = instanceCode || process.env.VUE_APP_INSTANCE_CODE || 'AR';
  const labels = FDS_BY_INSTANCE[code] || FDS_BY_INSTANCE['AR'];
  return labels.map(label => ({
    source: SOURCE_IDS[label] || null,
    sourceLabel: label
  })).filter(p => p.source !== null);
};

